export const iconFontAwesomeMapsRoad = (
	<i className="fa-solid fa-road"></i>
);
